<template>
  <div class="item-base">
    <user-detail-title
      first-bread="公司介绍"
      second-bread="公司介绍修改"
      first-url="/user/company"
      title-name="公司介绍修改"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="公司名称" :placeholder="LookData.name">
          <el-input v-model="LookData.name"></el-input>
        </el-form-item>
        <el-form-item label="公司logo" >
          <el-upload action="/api/photo/uploadFile" :on-success="GetLogoUrlList">
            <el-button slot="trigger" size="small" type="primary">选取Logo图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="短语" >
          <el-input type="textarea" :row="5" v-model="LookData.phrase" :placeholder="LookData.phrase"></el-input>
        </el-form-item>
        <el-form-item label="公司简介描述" >
          <ripeav-text-input v-model="LookData.description" :text-input="LookData.description"></ripeav-text-input>
<!--          <el-input type="textarea" :row="5" v-model="" :placeholder=""></el-input>-->
        </el-form-item>
        <el-form-item label="简介图片" >
          <el-upload action="/api/photo/uploadFile" :on-success="GetIntroUrlList">
            <el-button slot="trigger" size="small" type="primary">选取简介图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="公司愿景描述" >
          <el-input type="textarea" :row="5" v-model="LookData.visionDescription" :placeholder="LookData.visionDescription"></el-input>
        </el-form-item>
        <el-form-item label="愿景图片" >
          <el-upload action="/api/photo/uploadFile" :on-success="GetVisionUrlList">
            <el-button slot="trigger" size="small" type="primary">选取愿景图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="经营理念描述" >
          <el-input type="textarea" :row="5" v-model="LookData.manageIdeaDescription" :placeholder="LookData.manageIdeaDescription"></el-input>
        </el-form-item>
        <el-form-item label="经营理念图片" >
          <el-upload action="/api/photo/uploadFile" :on-success="GetIdeaUrlList">
            <el-button slot="trigger" size="small" type="primary">选取理念图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业文化描述" >
          <el-input type="textarea" :row="5" v-model="LookData.enterpriseCulture" :placeholder="LookData.enterpriseCulture"></el-input>
        </el-form-item>
        <el-form-item label="企业文化图片" >
          <el-upload action="/api/photo/uploadFile" :on-success="GetCultureUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文化图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="社会责任" >
          <el-input type="textarea" :row="5" v-model="LookData.worldDutyDescription" :placeholder="LookData.worldDutyDescription"></el-input>
        </el-form-item>
        <el-form-item label="社会责任图片" >
          <el-upload action="/api/photo/uploadFile" :on-success="GetSocialUrlList">
            <el-button slot="trigger" size="small" type="primary">选取社会责任图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="公司邮箱" >
          <el-input v-model="LookData.email" type="email" :placeholder="LookData.email"></el-input>
        </el-form-item>

      </el-form>
    </user-detail-base>
    <el-button @click="HandleChange">修改</el-button>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  import RipeavTextInput from "@/components/tinymce/RipeavTextInput";
  export default {
    name: "CompanyChange",
    components: {RipeavTextInput, UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:{
          id: '1'
        },
        // LookData:{}
      }
    },
    created() {
      this.GetData()
    },
    methods:{
      GetLogoUrlList(file){
        this.LookData.logoUrl=file.data;
      },
      GetIntroUrlList(file){
        this.LookData.introPhotoUrl=file.data;
      },
      GetVisionUrlList(file){
        this.LookData.visionPhotoUrl=file.data;
      },
      GetIdeaUrlList(file){
        this.LookData.ideaPhotoUrl=file.data;
      },
      GetCultureUrlList(file){
        this.LookData.culturePhotoUrl=file.data;
      },
      GetSocialUrlList(file){
        this.LookData.worldDutyPhotoUrl=file.data;
      },
      HandleChange(){

        if (this.LookData.id !== 1){
          this.$message.warning('请修改内容后再提交')
        } else {

          console.log(this.LookData.id)

          this.$axios.post('/api/companyIntro/update',this.LookData).then(res=>{
            if(res.data.success == true){
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        }
      },
      GetData(){
        this.$axios.get('/api/companyIntro/getCompanyIntro').then(res=>{
          this.LookData=res.data.data
        })
      },

    }
  }
</script>

<style scoped>

</style>